import { useEffect, useContext } from 'react';
import { useGlobalState, useMasterData, useWalletMaster } from 'mmbclient/Common/CommonHooks';
import { GLOBAL_CONTEXT, MASTERdATA, WALLET } from 'mmbclient/Common/CommonVariable'
import AuthRouting from 'mmbclient/Components/AuthRouting';
import { checkSession } from 'mmbclient/Common/CommonService';
import FastBooking from 'mmbclient/Booking/FastBooking';
import Nothing from './Nothing';

const Main = () => {
    return (
        <GLOBAL_CONTEXT.Provider value={useGlobalState()}>
            <MASTERdATA.Provider value={useMasterData()}>
                <WALLET.Provider value={useWalletMaster()}>
                    <Start />
                </WALLET.Provider>
            </MASTERdATA.Provider>
        </GLOBAL_CONTEXT.Provider>
    );
}

const Start = () => {

    const store = useContext(GLOBAL_CONTEXT);

    useEffect(() => {
        checkSession(store);
    }, []);

    return (
        <AuthRouting />
    );
}

export default Main
